import { forwardRef, memo } from 'react';
import { DistributiveOmit } from 'types';
import { ReactComponent as MailIcon } from 'assets/icons/mail.svg';
import { Input } from '../input';
import type { InputProps } from '../input.types';

/**
 * Поле почты: тип, режим клавиатуры, автозаполнение и иконка.
 *
 * Проверять адрес — не его дело. Правило живёт в utils/validate-utils
 * (checkValidEmail синхронизирован с бэком), а статус и текст ошибки задаёт
 * форма.
 */
export const EmailInput = memo(
  forwardRef<HTMLInputElement, DistributiveOmit<InputProps, 'type'>>(
    (props, ref) => (
      <Input
        ref={ref}
        type="email"
        inputMode="email"
        autoComplete="email"
        prefix={<MailIcon aria-hidden />}
        {...props}
      />
    )
  )
);

EmailInput.displayName = 'EmailInput';
